/**
 * en-GB messages added by Phase 1 task W7 (docs/PHASE-1-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const w7EnGB = {
    // List page
    'agreementsUi.title': 'Agreements',
    'agreementsUi.description': 'Signed notices, sealed and verifiable.',
    'agreementsUi.table': 'Signed agreements',
    'agreementsUi.empty': 'No signed agreements yet.',
    'agreementsUi.filter.site': 'Site',
    'agreementsUi.filter.allSites': 'All sites',
    'agreementsUi.filter.status': 'Status',
    'agreementsUi.filter.allStatuses': 'All statuses',
    'agreementsUi.search.hint': 'Person, notice or site',
    'agreementsUi.col.seq': 'No.',
    'agreementsUi.col.person': 'Person',
    'agreementsUi.col.notice': 'Notice',
    'agreementsUi.col.site': 'Site',
    'agreementsUi.col.accepted': 'Accepted',
    'agreementsUi.col.status': 'Status',
    'agreementsUi.col.actions': 'Actions',
    'agreementsUi.status.pending': 'Being sealed',
    'agreementsUi.status.sealed': 'Sealed',
    'agreementsUi.status.failed': 'Failed',
    'agreementsUi.status.redacted': 'Personal details removed',
    'agreementsUi.redactedName': 'Removed',
    'agreementsUi.noticeVersion': '{title} (version {version})',
    'agreementsUi.open': 'Open {name}',
    'agreementsUi.retry': 'Retry sealing',
    'agreementsUi.retry.done': 'Sealing has been tried again.',
    // Chain status card
    'agreementsUi.chain.title': 'Chain check',
    'agreementsUi.chain.ok': 'Chain intact',
    'agreementsUi.chain.broken': 'Chain broken',
    'agreementsUi.chain.never': 'Not checked yet',
    'agreementsUi.chain.checked': 'Last checked {when}. {count} agreements in the chain.',
    'agreementsUi.chain.brokenHelp': 'An earlier record has been changed or removed. Contact support.',
    'agreementsUi.chain.timestamped': 'Latest trusted timestamp {when}.',
    // Drawer
    'agreementsUi.drawer.title': 'Agreement {seq}',
    'agreementsUi.drawer.titlePending': 'Agreement (not yet sealed)',
    'agreementsUi.drawer.close': 'Close',
    'agreementsUi.detail.person': 'Person',
    'agreementsUi.detail.notice': 'Notice',
    'agreementsUi.detail.site': 'Site',
    'agreementsUi.detail.group': 'Group',
    'agreementsUi.detail.device': 'Device',
    'agreementsUi.detail.accepted': 'Accepted',
    'agreementsUi.detail.sealed': 'Sealed',
    'agreementsUi.detail.signature': 'Signature drawn',
    'agreementsUi.detail.fingerprint': 'PDF fingerprint (SHA-256)',
    'agreementsUi.detail.none': 'None',
    'agreementsUi.download': 'Download PDF',
    'agreementsUi.download.failed': 'The PDF could not be downloaded.',
    'agreementsUi.redactedNote': 'The personal details and the PDF were removed under the retention rules. The chain entry is kept.',
    // Verify
    'agreementsUi.verify.button': 'Verify',
    'agreementsUi.verify.running': 'Checking…',
    'agreementsUi.verify.title': 'Verification result',
    'agreementsUi.verify.fingerprint': 'Fingerprint matches',
    'agreementsUi.verify.fingerprint.ok': 'The stored PDF is exactly the one that was sealed.',
    'agreementsUi.verify.fingerprint.bad': 'The stored PDF has changed since it was sealed.',
    'agreementsUi.verify.fingerprint.na': 'Not applicable: the PDF was removed under the retention rules.',
    'agreementsUi.verify.chain': 'Chain unbroken',
    'agreementsUi.verify.chain.ok': 'Every earlier agreement is present and unchanged, up to number {seq}.',
    'agreementsUi.verify.chain.bad': 'A record in the chain has been changed or is missing.',
    'agreementsUi.verify.signature': 'Signature valid',
    'agreementsUi.verify.signature.ok': 'The PDF carries a valid CloudSign digital signature.',
    'agreementsUi.verify.signature.bad': 'The digital signature does not check out.',
    'agreementsUi.verify.signature.na': 'Not applicable: the PDF was removed under the retention rules.',
    'agreementsUi.verify.passed': 'Passed',
    'agreementsUi.verify.failed': 'Failed',
    'agreementsUi.verify.skipped': 'Not applicable',
    'agreementsUi.verify.timestamp': 'Trusted timestamp: this record existed by {when}.',
    'agreementsUi.verify.noTimestamp': 'No trusted timestamp covers this record yet.',
    'agreementsUi.verify.problems': 'Problems found',
    'agreementsUi.verify.problem': 'Entry {seq}: {message}',
    'agreementsUi.verify.problemNoSeq': '{message}',
    // Problems the server reports (mock keys until S8 fixes the real ones)
    'agreementsUi.problem.pdfChanged': 'The stored PDF no longer matches its fingerprint.',
    'agreementsUi.problem.chainGap': 'A record is missing or has been changed.',
    // Visit drawer section
    'agreementsUi.visit.title': 'Agreements',
    'agreementsUi.visit.none': 'No signed agreements for this visit.',
    'agreementsUi.visit.item': '{title} (version {version}), accepted {when}',
    // Public verify page
    'agreementsUi.public.title': 'Verify a signed agreement',
    'agreementsUi.public.intro': 'Upload a PDF you were given. We will tell you whether it is a genuine, untouched CloudSign agreement. The file is checked and not kept, and the result shows no personal details.',
    'agreementsUi.public.file': 'PDF file',
    'agreementsUi.public.check': 'Check this PDF',
    'agreementsUi.public.checking': 'Checking…',
    'agreementsUi.public.notPdf': 'Please choose a PDF file.',
    'agreementsUi.public.tooBig': 'That file is larger than 10 MB.',
    'agreementsUi.public.noFile': 'Choose a PDF file first.',
    'agreementsUi.public.result': 'Result',
    'agreementsUi.public.found': 'Found',
    'agreementsUi.public.found.yes': 'This is a sealed CloudSign agreement.',
    'agreementsUi.public.found.no': 'This file does not match any sealed CloudSign agreement. It may have been altered.',
    'agreementsUi.public.sealed': 'Sealed on {when}.',
    'agreementsUi.public.signature': 'Signature valid',
    'agreementsUi.public.signature.yes': 'The digital signature was made by a CloudSign signing key.',
    'agreementsUi.public.signature.no': 'The digital signature is missing or invalid.',
    'agreementsUi.public.chain': 'Chain verified',
    'agreementsUi.public.chain.yes': 'The records it belongs to passed their latest check on {when}.',
    'agreementsUi.public.chain.no': 'The records it belongs to did not pass their latest check.',
    'agreementsUi.public.chain.na': 'Not applicable, because the file was not found.',
    'agreementsUi.public.genuine': 'This looks like a genuine, untouched agreement.',
    'agreementsUi.public.notGenuine': 'This file could not be confirmed as a genuine agreement.',
    'agreementsUi.public.certificate': 'Download the CloudSign certificate',
};
//# sourceMappingURL=w7.js.map